module.exports = __webpack_public_path__ + "static/news-7a0d7ef2b637d552f0cc8517ab8bbddb.png";